import styled from 'styled-components';

import {
  Input as SemanticInput,
  Icon as SemanticIcon,
  TextArea as SemanticTextArea,
  Form as SemanticForm,
} from 'semantic-ui-react';

import MaskedInputComponent from 'react-text-mask';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Header = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Title = styled(TextLayoutComponent.Span)`
  font-size: 16px;
  font-weight: 450;
`;

export const Time = styled.div`
  align-items: center;
  display: flex;
  margin-top: 10px;
`;

export const Form = SemanticForm;

export const TextArea = styled(SemanticTextArea)`
  &&&{
    resize: none;
  }
`;

export const Input = styled(SemanticInput)`
  &.ui.input {
    width: 100%;
  }
  &&&&& > input {
    border: unset;
  }
  display: flex;
  justify-content: space-between;
  
  ${({ error, theme }) => (error && `
      &&&.ui.input.error>input {
        background-color: ${theme.color.inputBackgroundError}; 
        color: ${theme.color.error};
        box-shadow: none;
      }`)}

`;

export const Separator = styled(TextLayoutComponent.Span)`
  margin: 0 10px;
`;

export const SaveButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 16px;
    margin-top: 10px;
    width: 100%;
    ${({ error, theme }) => (error && `
      background: ${theme.color.categorizingBackground};
      color: ${theme.color.text};
      opacity: 1 !important;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 15px;
    `)};
  }
`;

export const Icon = styled(SemanticIcon)`
  line-height: 1;

  &&& {
    color: rgb(133,133,133);
    cursor: pointer;
    margin: 0px;
  }
`;

export const ContainerArrows = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 11px;
`;

export const ContainerInput = styled.div`
  display: flex;
  border: 1px solid ${({ error, theme }) => (error ? `${theme.color.inputBorderError}` : `${theme.color.inputBorder}`)};
  border-radius: 2px;
  align-items: center;
`;

export const MaskedInput = styled(MaskedInputComponent)`
  &&&& {
    border: unset;
  }
  ${({ error, theme }) => (error && `
      &&&& {
        background-color: ${theme.color.inputBackgroundError}; 
        color: ${theme.color.error};
        box-shadow: none;
      }`)}
`;
